import { ApolloClient } from '@apollo/client';
import cache from './cache';

const client = new ApolloClient({
  uri: process.env.REACT_APP_GRAPHQL_SERVER_URI,
  cache,
});

export default client;
